import React from 'react'
import Main from './Main'
import Sidebar from './Sidebar'

const Userlayout = () => {
  return (
    <section className='user-structure'>
        <Sidebar/>
        <Main/>
        
    </section>
  )
}

export default Userlayout